export default __webpack_public_path__ + "static/media/Rectangle -1.e9b1da13.png";